import shortid from "shortid";
import { notification } from "../../services";
import { CadastrarEnderecoFornecedorXml } from "./entities";

const meioPagamentoEnum = {
  "01": "fpDinheiro",
  "02": "fpCheque",
  "03": "fpCartaoCredito",
  "04": "fpCartaoDebito",
  "05": "fpCreditoEmLoja",
  10: "fpValeAlimentacao",
  11: "fpValeRefeicao",
  12: "fpValePresente",
  13: "fpValeCombustivel",
  14: "fpDuplicataMercantil",
  15: "fpBoletoBancario",
  16: "fpDepositoBancario",
  17: "fpPagamentoInstantaneoPIXDinamico",
  18: "fpTransferenciabancaria",
  19: "fpProgramadefidelidade",
  20: "fpPagamentoInstantaneoPIXEstatico",
  90: "fpSemPagamento",
  99: "fpOutro",
};

export function enderecoFornecedor(endereco) {
  const enderecoFornecedor = new CadastrarEnderecoFornecedorXml();
  enderecoFornecedor.setEnderecoCadastrado(endereco);
  return enderecoFornecedor;
}

export function parseXml(content) {
  const parser = new DOMParser();
  return parser.parseFromString(content, "application/xml");
}

export function convertXmlToJson(xml) {
  const obj = {};
  if (xml.nodeType === 1) {
    if (xml.attributes.length > 0) {
      for (let j = 0; j < xml.attributes.length; j++) {
        const attribute = xml.attributes.item(j);
        obj[attribute.nodeName] = attribute.nodeValue;
      }
    }
  }
  if (xml.hasChildNodes()) {
    for (let i = 0; i < xml.childNodes.length; i++) {
      const item = xml.childNodes.item(i);
      const nodeName = item.nodeName;
      if (typeof obj[nodeName] === "undefined") {
        obj[nodeName] =
          item.childNodes?.length && item.childNodes[0].nodeName === "#text"
            ? item.childNodes[0].nodeValue
            : convertXmlToJson(item);
      } else {
        if (typeof obj[nodeName].push === "undefined") {
          const old = obj[nodeName];
          obj[nodeName] = [];
          obj[nodeName].push(old);
        }
        obj[nodeName].push(convertXmlToJson(item));
      }
    }
  }
  return obj;
}

export function formatImpostos(impostos) {
  return Object.keys(impostos).reduce((impostosFormatados, imposto) => {
    const subImposto =
      typeof impostos[imposto] === "object"
        ? Object.entries(impostos[imposto]).reduce(
            (acc, [chave, valor]) => ({
              ...acc,
              ...(typeof valor === "object" ? valor : { [chave]: valor }),
            }),
            {},
          )
        : impostos[imposto];
    return { ...impostosFormatados, [imposto]: subImposto };
  }, {});
}

function getEnumPagamento(codigo) {
  return meioPagamentoEnum[codigo] ? meioPagamentoEnum[codigo] : codigo;
}

export function getPagamentoDuplicataXml(
  pagamentos = [],
  duplicatas = [],
  dataEmissao,
) {
  const hasPagamentos = pagamentos.length > 0;
  const hasDuplicatas = duplicatas.length > 0;
  if (!hasPagamentos || (!hasDuplicatas && pagamentos.length > 1)) {
    return [];
  }
  const montarPagamento = (duplicata, pagamento) => ({
    ...duplicata,
    tPag: getEnumPagamento(pagamento.tPag),
  });
  if (pagamentos.length === duplicatas.length) {
    return duplicatas.map((d, i) => montarPagamento(d, pagamentos[i]));
  }
  if (duplicatas.length > pagamentos.length) {
    const tPag = getEnumPagamento(pagamentos[0].tPag);
    return duplicatas.map((d) => ({ ...d, tPag }));
  }
  return pagamentos.map((pagamento, index) => {
    if (index === 0) {
      return {
        nDup: Math.floor(Math.random() * 200),
        dVenc: dataEmissao,
        vDup: pagamento.vPag,
        tPag: getEnumPagamento(pagamento.tPag),
      };
    }
    const duplicata = duplicatas[index - 1];
    return montarPagamento(duplicata, pagamento);
  });
}

export function extrairDadosNFe(xmlData, funcaoResetState) {
  const {
    nfeProc: {
      NFe,
      protNFe: { infProt },
    },
  } = convertXmlToJson(xmlData);
  if (!NFe) {
    funcaoResetState?.();
    return notification.alertaGenericos(
      "Por favor, inserir XML referente a NF-e",
    );
  }
  const objetoFormatDto = {
    fornecedor: NFe.infNFe?.emit,
    identificacao: NFe.infNFe?.ide,
    protocolo: infProt,
    transporte: NFe.infNFe?.transp,
    itens: Array.isArray(NFe.infNFe?.det)
      ? NFe.infNFe?.det.map((item) => {
          const imposto = formatImpostos(item.imposto);
          const itemFormatado = {
            ...item,
            imposto,
          };
          return itemFormatado;
        })
      : [
          {
            ...NFe.infNFe.det,
            imposto: formatImpostos(NFe.infNFe.det?.imposto),
          },
        ],
    totais: NFe.infNFe.total.ICMSTot,
    totaisIBSCBS: NFe.infNFe.total.IBSCBSTot,
    pagamentos: NFe.infNFe?.pag.detPag,
    duplicatas: NFe.infNFe?.cobr?.dup,
    informacoes: NFe.infNFe?.infAdic,
  };
  if (NFe.infNFe?.pag.detPag) {
    if (!Array.isArray(NFe.infNFe?.pag.detPag)) {
      objetoFormatDto.pagamentos = [NFe.infNFe?.pag.detPag];
    }
  }
  if (NFe.infNFe?.cobr?.dup) {
    if (!Array.isArray(NFe.infNFe?.cobr?.dup)) {
      objetoFormatDto.duplicatas = [NFe.infNFe?.cobr?.dup];
    }
  }
  return objetoFormatDto;
}

export function cadastroProdutosDto(produto, index) {
  const cadastroProduto = {
    ...produto,
    id: produto?.produtoId || shortid.generate(),
    ordem: index + 1,
  };
  if (!produto?.produtoId) {
    cadastroProduto.fornecedores = [
      {
        fornecedorId: produto.fornecedorId,
        codigoProduto: produto.codigoProduto,
        quantidadeEmbalagem: produto.quantidadeEmbalagem,
      },
    ];
  }
  return cadastroProduto;
}

export function encontrarProduto(
  item,
  listaProdutosFornecedor = [],
  listaProdutosBarra = [],
) {
  if (!item) return null;
  if (listaProdutosBarra?.length && item.codigoBarra) {
    const produtoPorBarra = listaProdutosBarra.find(
      (prod) => prod.codigoBarra && prod.codigoBarra === item.codigoBarra,
    );
    if (produtoPorBarra) return produtoPorBarra;
  }
  if (listaProdutosFornecedor?.length && item.codigoProduto) {
    const produtoPorCodigo = listaProdutosFornecedor.find(
      (prod) => prod.codigoProduto === item.codigoProduto,
    );
    if (produtoPorCodigo) return produtoPorCodigo;
  }
  return null;
}

export function ordenarPorDescricao(array) {
  if (!Array.isArray(array)) return [];
  return [...array].sort((a, b) => {
    const descricaoA =
      typeof a?.descricao === "string" ? a.descricao.trim() : "";

    const descricaoB =
      typeof b?.descricao === "string" ? b.descricao.trim() : "";

    return descricaoA.localeCompare(descricaoB, "pt-BR", {
      sensitivity: "base",
      ignorePunctuation: true,
    });
  });
}

export function erroCelulaGridProdutos(params, inputErros) {
  if (!inputErros || !params) return "";
  const indiceItem = params.api.getRowIndexRelativeToVisibleRows(params.row.id);
  return inputErros.get(`[${indiceItem}].${params.field}`);
}

export function calculaSubtotaisProdutos(lista, key) {
  if (lista?.length > 0) {
    return lista.reduce((acumulador, objetoAtual) => {
      return acumulador + parseFloat(objetoAtual[key]);
    }, 0);
  }
  return 0;
}
